import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Enroll',
    component: () => import('@/pages/Enroll.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/Home/index.vue')
  },
  // 聚合招募新增页面
  {
    path: '/focusIndex', // 进来进行定位，根据是否获取到定位进行页面跳转
    name: 'focusIndex',
    component: () => import('@/pages/recruitFocusIndex/index.vue')
  },
  {
    path: '/cityList',
    name: 'CityList',
    component: () => import('@/pages/AllCityList.vue')
  },
  {
    path: '/cpList',
    name: 'CpList',
    component: () => import('@/pages/RecruitCpList.vue')
  },
  {
    path: '/serviceAgrment',
    name: 'serviceAgrment',
    component: () => import('@/pages/ServiceAgrment.vue')
  }
]

const router = new VueRouter({
  routes
})
export default router
